import { render } from "./OrderStatus.vue?vue&type=template&id=0ecc9d29"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SOURCE VUE JS\\ksm-ionic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__